module.exports = __webpack_public_path__ + "media/WoveonResponseFramework.035eee87.mp4";